import React, { useMemo } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import WbSunnyRoundedIcon from '@mui/icons-material/WbSunnyRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import NightsStayRoundedIcon from '@mui/icons-material/NightsStayRounded';
import WavingHandRoundedIcon from '@mui/icons-material/WavingHandRounded';

function resolveGreeting(date = new Date()) {
  const hour = date.getHours();
  if (hour >= 5 && hour < 12) {
    return {
      title: 'Доброе утро',
      Icon: WbSunnyRoundedIcon,
      tone: 'rgba(245, 158, 11, 0.14)',
      color: '#B45309',
    };
  }
  if (hour >= 12 && hour < 18) {
    return {
      title: 'Добрый день',
      Icon: WavingHandRoundedIcon,
      tone: 'rgba(52, 120, 246, 0.12)',
      color: '#1D4ED8',
    };
  }
  if (hour >= 18 && hour < 23) {
    return {
      title: 'Добрый вечер',
      Icon: DarkModeRoundedIcon,
      tone: 'rgba(99, 102, 241, 0.12)',
      color: '#4338CA',
    };
  }
  return {
    title: 'Доброй ночи',
    Icon: NightsStayRoundedIcon,
    tone: 'rgba(30, 64, 175, 0.12)',
    color: '#1E3A8A',
  };
}

function firstName(user) {
  const raw = (user?.full_name || user?.username || '').trim();
  if (!raw) return '';
  return raw.split(/\s+/)[0];
}

export default function HomeGreeting({ user }) {
  const greeting = useMemo(() => resolveGreeting(), []);
  const name = firstName(user);
  const Icon = greeting.Icon;

  return (
    <Box
      className="card-pop"
      sx={{
        mb: 2,
        p: { xs: 1.75, md: 2.25 },
        borderRadius: 3.5,
        border: '1px solid rgba(15, 23, 42, 0.06)',
        background:
          'linear-gradient(135deg, rgba(255,255,255,0.92) 0%, rgba(244,248,255,0.95) 100%)',
        boxShadow: '0 10px 28px rgba(15, 23, 42, 0.04)',
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
          sx={{
            width: 46,
            height: 46,
            borderRadius: 2.5,
            display: 'grid',
            placeItems: 'center',
            background: greeting.tone,
            color: greeting.color,
            flexShrink: 0,
          }}
        >
          <Icon fontSize="small" />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontWeight: 800,
              letterSpacing: '-0.02em',
              fontSize: { xs: 20, md: 22 },
              lineHeight: 1.2,
              color: '#0F172A',
            }}
          >
            {greeting.title}
            {name ? `, ${name}` : ''}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
